import { useCallback, useEffect, useRef } from 'react';
import { useJsApiLoader } from '@react-google-maps/api';

const LIBRARIES = ['places'];

// Shared Google Places Autocomplete/PlacesService setup, reused by every
// address-search input (region-only, full-address, map pin) so the
// AutocompleteService/PlacesService boilerplate exists in exactly one place.
export const useGooglePlacesAutocomplete = () => {
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey:
      process.env.REACT_APP_GOOGLE_MAPS_API_KEY || 'YOUR_API_KEY_HERE',
    libraries: LIBRARIES,
  });

  const autocompleteServiceRef = useRef(null);
  const placesServiceRef = useRef(null);

  useEffect(() => {
    if (isLoaded && window.google && !autocompleteServiceRef.current) {
      autocompleteServiceRef.current =
        new window.google.maps.places.AutocompleteService();
      const dummyEl = document.createElement('div');
      placesServiceRef.current = new window.google.maps.places.PlacesService(
        dummyEl,
      );
    }
  }, [isLoaded]);

  const getPlacePredictions = useCallback((request, callback) => {
    if (!autocompleteServiceRef.current) return;
    autocompleteServiceRef.current.getPlacePredictions(request, callback);
  }, []);

  const getPlaceDetails = useCallback((request, callback) => {
    if (!placesServiceRef.current) return;
    placesServiceRef.current.getDetails(request, callback);
  }, []);

  return { isLoaded, getPlacePredictions, getPlaceDetails };
};
